// import _get from 'lodash.get';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
//import makeRequest from '../../utils/makeRequest';
//import * as cookie from '../../utils/cookies';

const reducerName = 'homepage_etimes';
const createActionName = name => `toi/${reducerName}/${name}`;

const ETIMES_WEB_HP_CONTENT_FEED_PATH = '/toi/web/list/etimesnews?version=v2';
const ETIMES_WAP_HP_CONTENT_FEED_PATH =
  '/toi/web/list/etimesnews?version=v2&ismobile=true';
export const RECEIVE_HOME_PAGE_DATA = createActionName(
  'RECEIVE_HOME_PAGE_DATA',
);

export const HANDLE_HOME_PAGE_DATA_ERROR = createActionName(
  'HANDLE_DATA_ERROR',
);

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

function fetchEtimesHomePageData(params) {
  const requestParams = {
    params: {},
  };

  const feedPath = params.isWapView
    ? ETIMES_WAP_HP_CONTENT_FEED_PATH
    : ETIMES_WEB_HP_CONTENT_FEED_PATH;

  // @todo there could be array of permissible params and those can be read in loop to form the URL parameters ?
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  const geoclParam = params.geocl ? `&geocl=${params.geocl}` : '';
  const geolocationParam = params.geolocation
    ? `&geolocation=${params.geolocation}`
    : '';
  const url = `${getFeedUrl()}${feedPath}&path=${
    params.fullPath
  }${primeParam}${geoclParam}${geolocationParam}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function handleHomePageDataError() {
  return {
    type: HANDLE_HOME_PAGE_DATA_ERROR,
    payload: {},
  };
}

function reciveHomePageData(data) {
  return {
    type: RECEIVE_HOME_PAGE_DATA,
    payload: data,
  };
}

export function loadHomePageData(params) {
  return dispatch => {
    dispatch(dataLoading());
    return fetchEtimesHomePageData(params)
      .then(response => {
        dispatch(dataLoaded());
        dispatch(reciveHomePageData(response.data, params));
      })
      .catch(error => {
        dispatch(dataLoaded());
        dispatch(handleHomePageDataError(error));
      });
  };
}

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_HOME_PAGE_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case HANDLE_HOME_PAGE_DATA_ERROR: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
